export default "__VITE_ASSET__mivWJ53q__"